
//Validaciones para todos los input de la app

import CurrencyInput from "react-currency-input-field";
import { regexEmail, regexName, regexNumber, regexMontoNumber } from "../helpers/regExp";
const CURRENT_MONTH = new Date().getMonth() + 1;
const CURRENT_YEARS = new Date().getFullYear();
function isFutureDate(value) { return new Date().getTime() <= new Date(value).getTime(); }

export const validationSingIn = (form, client) => {
  let error = {};
  if (form.selectDoc === "") { error.selectDoc = "Campo Obligatorio"; }
  else if (form.selectDoc === "Selección") { error.selectDoc = "Seleccione una opcion"; }
  if (!form.typeDoc || form.typeDoc.toString().length < 5) { error.typeDoc = "Campo Obligatorio"; }
  if (!form.password) { error.password = "Campo Obligatorio"; }
  return error;
};
export const validationSingUp = (form, stateValue, setStatebutton) => {

  let resCorreo = form.selectCorreo && JSON.parse(form.selectCorreo);
  let error = {};
  if ((!stateValue && resCorreo) || form.paso) {
    if (!resCorreo) { error.selectCorreo = "Seleccione una opcion"; }
    else if (resCorreo.nombre === "Seleccione un correo") { error.selectCorreo = "Seleccione una opcion"; }
    else if (!form.password) {
      error.password = "Campo Obligatorio";
      setStatebutton(true);
    } else if (form.password !== form.confirmPassword) {
      setStatebutton(true);
      error.confirmPassword = "Las contraseñas no coinciden. Inténtalo de nuevo.";
    } else { setStatebutton(false); }
  }
  else {
    setStatebutton(true);
    if (form.selectDoc === "") { error.selectDoc = "Campo Obligatorio"; }
    else if (form.selectDoc === "Selección") { error.selectDoc = "Seleccione una opcion"; }
    if (!form.typeDoc || form.typeDoc.toString().length < 5) { error.typeDoc = "Campo Obligatorio"; }
  }
  return error;
};
export const validationNewPassword = (form) => {
  let error = {};
  if (!form.newPass) { error.newPass = "Campo Obligatorio"; }
  if (!form.newPassConfirm) { error.newPassConfirm = "Campo Obligatorio"; }
  if (form.newPass !== form.newPassConfirm) { error.newPassConfirm = "Las contraseñas no son iguales"; }
  return error;
};
export const validationRecover = (form, validateState) => {
  let resCorreo = form.selectCorreo && JSON.parse(form.selectCorreo);
  let error = {};
   if (!validateState) 
  {
    if (!form.selectDoc) { error.selectDoc = "Campo Obligatorio"; }
    else if (form.selectDoc === "Selección") { error.selectDoc = "Seleccione una opcion"; }
    else if (!form.typeDoc) { error.typeDoc = "Campo Obligatorio"; }
  }
  else 
  {
    if (resCorreo === ""){ error.selectCorreo = "Seleccione una opcion"; }
    else if (!resCorreo) { error.selectCorreo = "Seleccione una opcion"; }
    else if (resCorreo.nombre === "Seleccione un correo") { error.selectCorreo = "Seleccione una opcion"; }
  }

  return error;
};
export const validatePayments = (form) => {
  let error = {};
  if (form.payments === "") { error.payments = true; }
  else { error.payments = false; }
  return error;
};
export const validateTypePayments = (form) => {
  let error = {};
  if (form.payments.payments === "") { error.payments = true; }
  else { error.payments = false; }
  return error;
};
export const validatePagoMovil = (form) => {
  let resBanco = JSON.parse(form.banks);
  let result = isFutureDate(form.date);
  let error = {};
  if (form.selectDoc === "") { error.selectDoc = "Campo Obligatorio"; }
  else if (form.selectDoc === "Seleccione") { error.selectDoc = "Seleccione una opcion"; }
  if (form.selectNumber === "") { error.selectNumber = "Campo Obligatorio"; }
  else if (form.selectNumber === "Seleccione") { error.selectNumber = "Seleccione una opcion"; }
  if (!form.typeDoc || form.typeDoc.toString().length < 5) { error.typeDoc = "Campo Obligatorio"; }
  if (form.phone === "" || form.phone.toString().length < 7) { error.phone = "Debes ingresar un campo"; }
  if (form.date === "") { error.date = "Debes ingresar un campo"; }
  else if (result) { error.date = "No puedes ingresar una fecha futura"; }
  if (!form.banks) { error.banks = "Debes ingresar un campo"; }
  else if (resBanco.nombre === "Seleccione un banco") { error.banks = "Debes ingresar un campo"; }
  if (form.numberReference === "" || form.numberReference.toString().length < 3) { error.numberReference = "Debes ingresar un campo"; }
  return error;
};
export const validatePagoMercantil = (form, setActiveButton) => {
  let error = {};
  if (form.selectDoc === "") { error.selectDoc = "Campo Obligatorio"; }
  else if (form.selectDoc === "Seleccione") { error.selectDoc = "Seleccione una opcion"; }
  if (!form.typeDoc || form.typeDoc.toString().length < 5) { error.typeDoc = "Campo Obligatorio"; }
  if (form.numberCard === "" || form.numberCard.toString().length < 18) { error.numberCard = "Debes ingresar un campo"; }
  if (form.dateExpirationDay === "") { error.dateExpirationDay = "Campo Obligatorio"; }
  else if (form.dateExpirationDay === "Seleccione") { error.dateExpirationDay = "Seleccione una opcion"; }
  if (form.dateExpirationMonth === "") { error.dateExpirationMonth = "Campo Obligatorio"; }
  else if (form.dateExpirationMonth === "Seleccione") { error.dateExpirationMonth = "Seleccione una opcion"; }
  if (form.name === "") { error.name = "Debes ingresar un campo"; }
  else if (!regexName.test(form.name.trim())) { error.name = "Campo oblogatorio"; }
  if (setActiveButton === true) {
    if (form.keyPhone === "" || form.keyPhone.toString().length < 8) { error.keyPhone = "Debes ingresar un campo"; }

  }
  if (form.typeAccount === "") { error.typeAccount = "Campo Obligatorio"; }
  else if (form.typeAccount === "Seleccione") { error.typeAccount = "Seleccione una opcion"; }
  if (form.code === "" || form.code.toString().length < 3) { error.code = "Debes ingresar un campo"; }
  return error;
};
export const validatePagoVenezuela = (form, emailCliente) => {
  let error = {};
  if (form.selectDoc === "") { error.selectDoc = "Campo Obligatorio"; }
  if (!form.typeDoc || form.typeDoc.toString().length < 5) { error.typeDoc = "Campo Obligatorio"; }
  if (form.selectNumber === "") { error.selectNumber = "Campo Obligatorio"; }
  else if (form.selectNumber === "Seleccione") { error.selectNumber = "Seleccione una opcion"; }
  if (form.tipoCuenta === "") { error.tipoCuenta = "Campo Obligatorio"; }
  else if (form.tipoCuenta === "Seleccione") { error.tipoCuenta = "Seleccione una opcion"; }
  if (emailCliente === "") { error.email = "Campo Obligatorio"; }
  else if (!regexEmail.test(emailCliente.trim())) { error.email = "Campo Obligatorio"; }
  return error;
};
export const validatePagoZelle = (form, emailCliente) => {
  let result = isFutureDate(form.date);
  let error = {};
  if (form.nameZelle === "") { error.nameZelle = "Campo Obligatorio"; }
  if (emailCliente === "") { error.email = "Campo Obligatorio"; }
  else if (!regexEmail.test(emailCliente.trim())) { error.email = "Campo oblogatorio"; }
  if (form.lastNameZelle === "") { error.lastNameZelle = "Campo Obligatorio"; }
  if (form.date === "") { error.date = "Debes ingresar un campo"; }
  else if (result) { error.date = "No puedes ingresar una fecha futura"; }
  return error;
};
export const validatePagoTarjetaCredito = (form, activeForm, emailCliente) => {

  let error = {};
  if (activeForm) {
    if (form.name === "") { error.name = "Debes ingresar un campo"; }
    else if (!regexName.test(form.name.trim())) { error.name = "Campo Obligatorio"; }
    if (form.numberCardCredit === "" || form.numberCardCredit.toString().length < 16) { error.numberCardCredit = "Debes ingresar un campo"; }
    if (emailCliente === "") { error.email = "Campo Obligatorio"; }
    else if (!regexEmail.test(emailCliente.trim())) { error.email = "Campo Obligatorio"; }
    if (form.cvvCard === "" || form.cvvCard.toString().length < 3) { error.cvvCard = "Campo Obligatorio"; }
    if (form.month === "Seleccione") { error.month = "Campo Obligatorio"; }
    else if (form.year === CURRENT_YEARS) { if (form.month < CURRENT_MONTH) { error.month = "Seleccione una opcion"; } }
    if (form.year === "Seleccione") { error.year = "Campo Obligatorio"; }
    else if (form.year > CURRENT_YEARS) { }
    else { if (form.month < CURRENT_MONTH) { error.month = "Seleccione una opcion"; } }
    if (form.keyCode === "") { error.keyCode = "Campo Obligatorio"; }
  }

  return error;
};
export const validateAmount = (form) => {

  let error = {};
  if (form.amount === "") { error.amount = "Debes ingresar un campo"; }
  return error;
};

export const validateCredicard = (form, validarToken, activeButton) => {
  let error = {};
  if (form.selectDoc === "") { error.selectDoc = "Campo Obligatorio"; }
  else if (form.selectDoc === "Seleccione") { error.selectDoc = "Seleccione una opcion"; }
  if (!form.typeDoc || form.typeDoc.toString().length < 5) { error.typeDoc = "Campo Obligatorio"; }
  if (form.numberCardCredicard === "" || form.numberCardCredicard.toString().length < 15) { error.numberCardCredicard = "Campo Obligatorio"; }
  if (!form.typeAccount) { error.typeAccount = "Campo Obligatorio"; }
  else if (form.typeAccount === "Seleccione") { error.typeAccount = "Seleccione una opcion"; }
  if (!form.month) { error.month = "Campo Obligatorio"; }
  else if (form.month === "Seleccione") { error.month = "Seleccione una opcion"; }
  if (!form.year) { error.year = "Campo Obligatorio"; }
  else if (form.year === "Seleccione") { error.year = "Seleccione una opcion"; }
  if (form.name === "") { error.name = "Campo Obligatorio"; }
  else if (!regexName.test(form.name.trim())) { error.name = "Debes ingresar un campo"; }
  if (form.cvc === "" || form.cvc.toString().length < 3) { error.cvc = "Campo Obligatorio"; }
  if (form.pinCard === "" || form.pinCard.toString().length < 4) { error.pinCard = "Campo Obligatorio"; }
  if (form.selectNumber === "") { error.selectNumber = "Campo Obligatorio"; }
  if (form.phone === "" || form.phone.toString().length < 7) { error.phone = "Campo Obligatorio"; }
  if (activeButton) { if (form.token === "" || form.token.toString().length < 6) { error.token = "Campo Obligatorio"; } }
    return error;
};
export const validatePagoMercantilTDC = (form) => {
  let error = {};
  if (form.selectDoc === "") { error.selectDoc = "Campo Obligatorio"; }
  else if (form.selectDoc === "Seleccione") { error.selectDoc = "Seleccione una opcion"; }
  if (!form.typeDoc || form.typeDoc.toString().length < 5) { error.typeDoc = "Campo Obligatorio"; }
  if (form.numberCardCredit === "" || form.numberCardCredit.toString().length < 16) { error.numberCardCredit = "Debes ingresar un campo"; }
  if (form.month === "Seleccione") { error.month = "Campo Obligatorio"; }
  else if (form.year === CURRENT_YEARS) { if (form.month < CURRENT_MONTH) { error.month = "Seelccione una opcion"; } }
   if (form.year === "Seleccione") { error.year = "Campo Obligatorio"; }
  else if (form.year > CURRENT_YEARS) { }
  else { if (form.month < CURRENT_MONTH) { error.month = "Seelccione una opcion"; } }
  if (form.code === "" || form.code.toString().length < 3) { error.code = "Debes ingresar un campo"; }
  return error;
};

export const validateNotificacionesCorpo = (form, emailCliente) => {
  let error = {};
  let result = isFutureDate(form.date);
  if (emailCliente === "") { error.email = "Campo Obligatorio"; }
  else if (!regexEmail.test(emailCliente)) { error.email = "Campo Obligatorio"; }
  if (form.selectNumber === "") { error.selectNumber = "Campo Obligatorio"; }
  else if (form.selectNumber === "Seleccione") { error.selectNumber = "Seleccione una opcion"; }
  if (form.phone === "" || form.phone.toString().length < 7) { error.phone = "Debes ingresar un campo"; }
  if (form.tipoNotificacion === "Pago") {
    if (form.tipoMoneda === "") { error.tipoMoneda = "Campo Obligatorio"; }
    else if (form.tipoMoneda === "Seleccione") { error.tipoMoneda = "Seleccione una opcion"; }
    if (form.bancoReceptor === "") { error.bancoReceptor = "Campo Obligatorio"; }
    else if (form.bancoReceptor === "Seleccione") { error.bancoReceptor = "Seleccione una opcion"; }
    if (form.cuentaReceptor === "") { error.cuentaReceptor = "Campo Obligatorio"; }
    else if (form.cuentaReceptor === "Seleccione") { error.cuentaReceptor = "Seleccione una opcion"; }
    if (form.date === "") { error.date = "Debes ingresar un campo"; }
    else if (result) { error.date = "No puedes ingresar una fecha futura"; }
    if (form.numberReference === "") { error.numberReference = "Debes ingresar un campo"; }
    if (form.monto === "" || form.monto === "0") { error.monto = "Campo Obligatorio"; }
  }

  return error;
};

export const validateDomiciliacion = (form, emailCliente, domiciliacionBanco) => {

  let error = {};
  if (emailCliente === "") { error.email = "Campo Obligatorio"; }
  else if (!regexEmail.test(emailCliente)) { error.email = "Campo Obligatorio"; }
  if (form.selectNumber === "") { error.selectNumber = "Campo Obligatorio"; }
  else if (form.selectNumber === "Seleccione") { error.selectNumber = "Seleccione una opcion"; }
  if (form.phone === "" || form.phone.toString().length < 7) { error.phone = "Debes ingresar un campo"; }
  if (domiciliacionBanco === "Otro Banco")
  {if (form.ctaBancariaAll === "" || form.ctaBancariaAll.length < 20) { error.ctaBancariaAll = "Campo Obligatorio"; }}
  else {if (form.cuentaBancaria === "" || form.cuentaBancaria.length < 16) { error.cuentaBancaria = "Campo Obligatorio"; }}
  
  return error;
};

export const validateDomiciliacionCredito = (form, emailCliente, nombreCliente) => {
  let error = {};
  if (nombreCliente === "") { error.nameCredito = "Campo Obligatorio"; }
  if (emailCliente === "") { error.email = "Campo Obligatorio"; }
  else if (!regexEmail.test(emailCliente)) { error.email = "Campo Obligatorio"; }
  if (form.selectNumber === "") { error.selectNumber = "Campo Obligatorio"; }
  else if (form.selectNumber === "Seleccione") { error.selectNumber = "Seleccione una opcion"; }
  if (form.phone === "" || form.phone.toString().length < 7) { error.phone = "Debes ingresar un campo"; }
  if (form.tipoTarjeta == "Diners Club")
  {if (form.numberCardCredit === "" || form.numberCardCredit.length < 14 || form.numberCardCredit.length > 14) { error.numberCardCredit = "Debes ingresar un campo"; }}
  else{if (form.numberCardCredit === "" || form.numberCardCredit.length < 16) { error.numberCardCredit = "Debes ingresar un campo"; }}
  
  if (form.tipoTarjeta === "") { error.tipoTarjeta = "Campo Obligatorio"; }
  else if (form.tipoTarjeta === "Seleccione") { error.tipoTarjeta = "Seleccione una opcion"; }
  if (form.month === "Seleccione") { error.month = "Campo Obligatorio"; }
  else if (form.year === CURRENT_YEARS) { if (form.month < CURRENT_MONTH) { error.month = "Seelccione una opcion"; } }
   if (form.year === "Seleccione") { error.year = "Campo Obligatorio"; }
  else if (form.year > CURRENT_YEARS) { }
  else { if (form.month < CURRENT_MONTH) { error.month = "Seelccione una opcion"; } }
  if (form.code === "" || form.code.length < 3) { error.code = "Debes ingresar un campo"; }
  return error;
};
export const validateDetalleTelefonia = (form) => {

  let error = {};
  if (form.dateIni === "") { error.dateIni = "Debes ingresar un campo"; }
  if (form.dateFin === "") { error.dateFin = "Debes ingresar un campo"; }
  return error;
};


export const validateAmountToPay = (debt, amount, type) => {
  debt = parseFloat(debt);
  amount = parseFloat(amount);
  let maxAmount;
  let minAmount = type === 1 ? 0 : 0;
    return { valid: true, msg: "" };
 
};
